/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_About_P1Inputs */

const en_vc_about_p1 = /** @type {(inputs: Vc_About_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft is an open-source vector illustration editor. It is a clean-room reimplementation of the Illustrator workflow, written in pure Rust with no Adobe code or assets, and it renders on the GPU so large documents stay smooth.`)
};

const zh_vc_about_p1 = /** @type {(inputs: Vc_About_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 是一款开源的矢量插画编辑器。它以「净室」方式重新实现了 Illustrator 的工作流程，纯 Rust 编写，不含任何 Adobe 代码或素材，并使用 GPU 渲染，大文件也能保持流畅。`)
};

/**
* | output |
* | --- |
* | "VectorCraft is an open-source vector illustration editor. It is a clean-room reimplementation of the Illustrator workflow, written in pure Rust with no Adobe..." |
*
* @param {Vc_About_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_about_p1 = /** @type {((inputs?: Vc_About_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_About_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_about_p1(inputs)
	return zh_vc_about_p1(inputs)
});
export { vc_about_p1 as "vc.about.p1" }